namespace Roodik.Game
{
	export class LocalizationKey
	{
		public static readonly BUTTON_PLAY:string = "button.play";
		public static readonly BUTTON_TRY_AGAIN:string = "button.tryagain";
		public static readonly BUTTON_OK:string = "button.ok";
		public static readonly BUTTON_CANCEL:string = "button.cancel";
		public static readonly BUTTON_AGREE:string = "button.agree";

		public static readonly MENU_TITLE:string = "menu.title";
		public static readonly MENU_SOUND:string = "menu.sounds";
		public static readonly MENU_MUSIC:string = "menu.music";

		public static readonly PIASTRES:string = "piastres";
		public static readonly PIASTRES_1:string = "piastres_1";
		public static readonly FROM_CAPTAIN:string = "from.captain";
		public static readonly ACCURACY:string = "for.accuracy";
		public static readonly FOUND:string = "found";
		public static readonly AWARD_FROM_SMALLETT:string = "award.from.smallett";
		public static readonly YOHOHO:string = "yohoho";
		public static readonly FOUND_PIASTRES:string = "found.piastres";
		public static readonly TIMES_UP:string = "times.up";
		public static readonly RESHUFFLE:string = "reshuffle";
		public static readonly REWARDED_VIDEO_DESCRIPTION:string = "rewarded.video.description";
		public static readonly HOORAY:string = "hooray";
		public static readonly LEVEL_COMPLETE_DESCRIPTION:string = "level.complete.description";
		public static readonly NO_MORE_MOVES:string = "nomoremoves";
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Localization/LocalizationKey.ts